import {ReactTooltip} from "../tooltips/ReactTooltip";
import {Header} from "@tanstack/react-table";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {EmblaIcons} from "../../emblaIcons";
import useScreenResolution from "../../hooks/useScreenResolution";
import './ReactTableStyles.scss';
import ReactContextMenuButton from "./ReactContextMenuButton";

type TableContextMenuProps<T> = {
    header: Header<T, unknown>
    enableColumnGrouping?: boolean;
}
const TableContextMenu = <T, >({header, enableColumnGrouping}: TableContextMenuProps<T>) => {
    const {isMobile} = useScreenResolution();
    return (
        <ReactTooltip selectId={header.column.id} clickable openOnClick delay={0}
                      additionalClasses={"tooltip-no-padding"}>
            <div className={"flex-container-column"}>
                {header.column.getCanPin() && !isMobile && (
                    <>
                        {header.column.getIsPinned() !== 'left' ? (
                            <ReactContextMenuButton
                                label={Localizer.dashboard_pinLeft()}
                                icon={EmblaIcons.ArrowLeft}
                                onClick={() => header.column.pin('left')}
                            />
                        ) : null}
                        {header.column.getIsPinned() ? (
                            <ReactContextMenuButton
                                label={Localizer.dashboard_unpin()}
                                icon={EmblaIcons.Close}
                                onClick={() => header.column.pin(false)}
                            />
                        ) : null}
                        {header.column.getIsPinned() !== 'right' ? (
                            <ReactContextMenuButton
                                label={Localizer.dashboard_pinRight()}
                                icon={EmblaIcons.ArrowRight}
                                onClick={() => header.column.pin('right')}
                            />
                        ) : null}
                    </>
                )}
                {header.column.getCanGroup() && enableColumnGrouping &&
                    <ReactContextMenuButton
                        label={header.column.getIsGrouped() ? Localizer.dashboard_fjernGruppering() : Localizer.dashboard_grupper()}
                        icon={header.column.getIsGrouped() ? EmblaIcons.List : EmblaIcons.ListAdd}
                        onClick={header.column.getToggleGroupingHandler()}
                    />
                }
            </div>
        </ReactTooltip>
    )
}
export default TableContextMenu;
